import React, { Component } from 'react'
import Radium from 'radium'
import SingleFormLayout from '../components/single-form-layout'
import { FORM_STYLES } from '../components/assets/forms-shared'
import { Helmet } from 'react-helmet'

const STYLES = {
  title: {
    fontSize: 30,
    width: '100%',
    marginBottom: 20
  },
  link: {
    textDecoration: 'none'
  },
  hr: {
    paddingTop: '5px',
    paddingBottom: '5px'
  },
  ul: {
    listStyle: 'none',
    marginLeft: 0,
    paddingLeft: '1em',
    textIndent: '-1em',
    lineHeight: 2,
    textAlign: 'left'
  },
  li: {
    paddingLeft: '10px'
  },
  ...FORM_STYLES
}

class WindowsLinux extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Haiku Animator | Create engaging animations for any app or website.</title>
          <meta name="description" content="Make Lottie animations or dynamic web components using Animator's timeline, stage, and design tool integrations." />
        </Helmet>

        <SingleFormLayout>
          <div style={STYLES.formWrap}>
            <h2 style={STYLES.title}>Haiku Animator for Windows & Linux</h2>
            <p style={STYLES.label}>Haiku Animator is now available on macOS and Windows.</p>
            <a style={FORM_STYLES.btnLink} key="download-link" href="/animator">Get Animator for Mac or Windows</a>
            <p style={STYLES.label}>For Linux, join the waitlist and you'll be the first to know when Haiku Animator for Linux is available.</p>
            <a style={FORM_STYLES.btnLink} href="https://goo.gl/forms/TW85npTUF7ofmAq02" target="_blank">JOIN THE LINUX WAITLIST</a>
            <a style={STYLES.link} href="/animator"><p>Back to Haiku Animator</p></a>
          </div>
        </SingleFormLayout>
      </div>
    )
  }

}

export default Radium(WindowsLinux)



// WEBPACK FOOTER //
// ./src/pages/windows-and-linux.js